import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

setOptions({
    key: 'AIzaSyBqXcYHv6YKjcRMiYoQo4C-SbGjAslgEgg',
    version: 'weekly'
});

const initMap = async (mapEl) => { 
    const { Map } = await importLibrary('maps');
    const { AdvancedMarkerElement } = await importLibrary('marker');

    // Get zoom data attr
    const zoom = parseFloat(mapEl.dataset.zoom);

    // Get lat and lng data attrs
    const { lat } = mapEl.dataset;
    const { lng } = mapEl.dataset;

    const latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
    };

    // Create gerenic map
    const mapArgs = {
        zoom: zoom || 16,
        center: latLng,
        mapId: '2ce24f158516b1a6',
        disableDefaultUI: true,
        backgroundColor: "#121212"
    };

    const map = new Map(mapEl, mapArgs);

    // Create icon object. themeUrl set in enqueue.php with wp_localize
    const icon = document.createElement('div');
    icon.classList.add('contact-content__map-marker');

    // Create marker instance.
    const marker = new AdvancedMarkerElement({
        map,
        position: latLng,
        content: icon
    });

    setTimeout(() => {
        mapEl.classList.add('loaded');
    }, 400);

    // Return map instance.
    return map;

};

export { initMap as default };
